import { render, staticRenderFns } from "./LandingPageLuxuryGold.vue?vue&type=template&id=285c843a&scoped=true&"
import script from "./LandingPageLuxuryGold.vue?vue&type=script&lang=js&"
export * from "./LandingPageLuxuryGold.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageLuxuryGold.vue?vue&type=style&index=0&id=285c843a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285c843a",
  null
  
)

export default component.exports